"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
function configureMargins(margin) {
    return {
        margin: margin,
        maxWidth: "calc(100vw - ".concat(2 * margin, "px)"),
        maxHeight: "calc(100vh - ".concat(2 * margin, "px)"),
    };
}
exports.default = (0, makeStyles_1.default)((0, styles_1.createStyles)({
    dialogPaper: __assign(__assign({ borderRadius: 8, backgroundColor: theme_1.default.colors.globalBackgroundLight }, configureMargins(80)), (_a = {}, _a[theme_1.default.breakpoints.down('md')] = configureMargins(40), _a[theme_1.default.breakpoints.down('xs')] = configureMargins(theme_1.default.globalPadding), _a)),
    modalPaper: {
        margin: 0,
        maxWidth: '100%',
        minWidth: '100%',
        backgroundColor: theme_1.default.colors.globalBackgroundLight,
        maxHeight: '100%',
    },
    alignTop: {
        alignItems: 'flex-start',
    },
    scrollPaper: {
        maxHeight: '100%',
    },
}));
